"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.config.fine.tuning': 'Scegli metodo di addestramento',
    'trainer.config.fine_tuning.lora_extension': 'Estensione LoRA',
    'trainer.config.fine_tuning.fulltrain': 'Addestramento Completo',
    'trainer.config.train': 'Inizia Addestramento',
};
